<div class="progress-bar-container">
  <div class="progress-bar-path">
    <div class="progress-bar-indicator"
         [ngStyle]="{width: (progress | async) +'%' }"></div>
  </div>
</div>